import React, { Component,useEffect,useLayoutEffect,useRef, useState } from 'react';
import { Column } from 'primereact/column';
import GenericGrid from '../../common/GenericGrid';
import CmsService from '../../../service/CmsService';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import CatTreeSelect, { CatSelectDialog } from '../../cat/CatTreeSelect';
import { SetProp } from './SetProp';
import { CommonDialog } from '../../common/CommonDialog';
import { CatSelectListDialog } from '../../cat/CatSelectList';
import { TestSearchDialog } from '../../scr/test/TestSearch';
import ScrService from '../../../service/ScrService';
import KeyValue from '../../common/KeyValue';
import { useTranslation } from 'react-i18next';
import { PrintDialog } from '../../scr/test/PrintDialog';


export function QueGrid({catId,query,mode,testId,sectId,selectionChanged,deleteMenu,nav,ancestorRect,showError}){
	const {t}=useTranslation();
	const [reload,setReload]=useState(true);
	const [catSelectDialog,setCatSelectDialog]=useState(false);
	const [catSelectListDialog,setCatSelectListDialog]=useState(false);
	const [propDialog,setPropDialog]=useState(false);
	const [searchTestDialog,setSearchTestDialog]=useState(false);
	const [printDialog,setPrintDialog]=useState(false);
	const [printMode,setPrintMode]=useState('pdf');
	const [selectedItems,setSelectedItems]=useState([]);
	const [lastCommand,setLastCommand]=useState('');
	const [test,setTest]=useState({});
	const [sect,setSect]=useState({});
	const [catType,setCatType]=useState(null);
	const [dummyTest,setDummyTest]=useState({testName:'Print',testNo:'0',term:'',testDate:'',testType:'',testId:0});
	const childRef = useRef(null);
	const [calculatedHeight, setCalculatedHeight] = useState('300px'); 

	useLayoutEffect(() => {
		if (!ancestorRect || !childRef.current) return;
		const childRect = childRef.current.getBoundingClientRect();
		const childRelativeTop = childRect.top - ancestorRect.top;
		const remainingHeight = ancestorRect.height - childRelativeTop - 75;
		setCalculatedHeight(remainingHeight>0?remainingHeight+'px':'300px');
	}, [ancestorRect]);

	useEffect(()=>{
		if(mode == 'addToTest')
			loadTestInfo();
	},[mode]);

    useEffect(()=>{
        setReload(true);
    },[query,catId]);

	useEffect(()=>{
		if(mode=='addToTest')
			loadTestInfo();
    },[mode,testId]);

	const loadRecords = (catId)=>{
		var ret = CmsService.getQuestions(catId,query.itemType,query.options,query.difficulty);
		ret.then(()=>{setReload(false)});

		return ret;
	}
	const loadTestInfo =()=>{
		ScrService.getTest(testId).then((test)=>{
			var sect=null;
			if(test && test.sects)
			{
				test.sects.forEach(sc => {
					if(sc.id == sectId)
						sect = sc;
				});	
			}
			setTest(test);
			setSect(sect);
		}).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
	}
	const commandMenuItems = [
			{label:t('Move'),action: 'move'},
			{label:t('Change_Property'),action: 'prop'},
			{label:t('Delete'),action: 'delete'},
			{label:t('Add_outcome'),action: 'addOutcome'},
			{label:t('Remove_outcome'),action: 'removeOutcome'},
			{label:t('Approve'),action: 'approve'},
			{label:t('Disapprove'),action: 'disapprove'},
			{label:t('Lock'),action: 'lock'},
			{label:t('Unlock'),action: 'unlock'},
			{label:t('Add_to_test'),action: 'addToTest'},
			{label:t('Print'),action: 'print'},
			{label:t('Generate_Doc'),action: 'gendoc'},
	];		

	const moveQuestions = (recs)=>{		
		setSelectedItems(recs);
		setLastCommand('move');
		setCatSelectDialog(true);
	}
	const addCat = (recs,catType)=>{
		setSelectedItems(recs);
		setLastCommand('addCat');
		setCatType(catType);
		setCatSelectListDialog(true);
	}
	const removeCat = (recs,catType)=>{
		setSelectedItems(recs);
		setLastCommand('removeCat');
		setCatType(catType);
		setCatSelectListDialog(true);
	}
	const changeProp = (recs)=>{		
		setSelectedItems(recs);
		setLastCommand('prop');
		setPropDialog(true);
	}
	const lockQuestions = (recs)=>{
		CmsService.lockQuestions(recs).then((ret)=>{
			setReload(true);
		}).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
	}
	const unlockQuestions = (recs)=>{
		CmsService.unlockQuestions(recs).then((ret)=>{
			setReload(true);
		}).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
	}
	const approveQuestions = (recs)=>{
		CmsService.approveQuestions(recs).then((ret)=>{
			setReload(true);
		}).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
	}
	const disapproveQuestions = (recs)=>{
		CmsService.disapproveQuestions(recs).then((ret)=>{
			setReload(true);
		}).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
	}
	const deleteQuestions = (recs)=>{
		CmsService.deleteQuestions(recs).then((ret)=>{
			setReload(true);
		}).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
	}
	const addToTest = (recs)=>{		
		if(mode=='addToTest')
		{
			ScrService.addQuestionsToTest(testId,sectId,recs).then((ret)=>{
				loadTestInfo();
			}).catch((error)=>{
            	showError(error.response.data?error.response.data.message:error.message);
        	});	
		}
		else
		{
			setSelectedItems(recs);
			setLastCommand('addToTest');
			setSearchTestDialog(true);
		}
	}
	const print = (recs)=>{
		setPrintMode('pdf');
		setSelectedItems(recs);
		setPrintDialog(true);
	}
	const gendoc = (recs)=>{
		setPrintMode('odt');
		setSelectedItems(recs);
		setPrintDialog(true);
	}
	const commandAction=(action,recs)=>{
		if(action == 'lock')
			lockQuestions(recs);
		else if(action == 'unlock')
			unlockQuestions(recs);
		else if(action == 'approve')
			approveQuestions(recs);
		else if(action == 'disapprove')
			disapproveQuestions(recs);
		else if(action == 'prop')
			changeProp(recs);
		else if(action == 'delete') //TODO ask for approve
			deleteQuestions(recs);
		else if(action == 'move')
			moveQuestions(recs);
		else if(action == 'addOutcome')
			addCat(recs,'OUTCOME');
		else if(action == 'removeOutcome')
			removeCat(recs,'OUTCOME');
		else if(action == 'addSkill')
			addCat(recs,'SKILL');
		else if(action == 'removeSkill')
			removeCat(recs,'SKILL');
		else if(action == 'addToTest')
			addToTest(recs);
		else if(action == 'print')
			print(recs);
		else if(action == 'gendoc')
			gendoc(recs);
	}
	const editQuestion = (que)=>{
        nav('/question/'+que.id);
    }
	const selectionChangedCallback=(rec)=>{
		if(selectionChanged)
			selectionChanged(rec);
	}
	const itemTypeTemplate=(rec)=>{
		var qt=rec.itemType;
		if(qt == 'MC' || qt == 'MR')
			qt=qt+'-'+rec.options;
		return qt;
	}
	const grpTemplate=(rec)=>{
		return (<>{rec.parentId>0?<i className="pi pi-angle-right custom-target-icon" data-pr-tooltip={rec.groupName}></i>:<></>}</>)
	}
	const approveTemplate=(rec)=>{
		return (<>{rec.approved?<i className="pi pi-check"></i>:<></>}</>)
	}
	const lockTemplate=(rec)=>{
		return (<>{rec.locked?<i className="pi pi-lock"></i>:<></>}</>)
	}
	const idTemplate=(rec)=>{
		if(rec.versionId && rec.versionId>1)
			return rec.id + "/" + rec.versionId;
		return rec.id;
	}
	const onCatSelectOK=(catId)=>{
		CmsService.moveQuestions(selectedItems,catId).then((ret)=>{
			setReload(true);
		}).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
		setCatSelectDialog(false);
	}
	const onCatSelectCancel=()=>{setCatSelectDialog(false)};

	const onPrintOK=()=>{
		setPrintDialog(false);
	};
	const onPrintCancel=()=>{
		setPrintDialog(false);
	};

	const onCatSelectListOK=(cat)=>{
		if((lastCommand == 'addOutcome')||(lastCommand == 'addSkill'))
		{
			CmsService.addQuestionsToCat(selectedItems,cat.id).then((ret)=>{
				setReload(true);
			}).catch((error)=>{
            	showError(error.response.data?error.response.data.message:error.message);
        	});	
		}
		if((lastCommand == 'removeOutcome')||(lastCommand == 'removeSkill'))
		{
			CmsService.removeQuestionsFromCat(selectedItems,cat.id).then((ret)=>{
				setReload(true);
			}).catch((error)=>{
           		showError(error.response.data?error.response.data.message:error.message);
        	});	
		}
		setCatSelectListDialog(false);
	};
	const onCatSelectListCancel=()=>{setCatSelectListDialog(false)};

	const onSetPropOK=(prop)=>{
		CmsService.setQuestionProperty(selectedItems,prop.propType,prop.propValue).then((ret)=>{
			setReload(true);
		}).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
		setPropDialog(false);
	}
	const onSetPropCancel=()=>{setPropDialog(false)}
	const onSearchTestOK=(testId,sectId)=>{
		ScrService.addQuestionsToTest(testId,sectId,selectedItems).then((ret)=>{
			setSearchTestDialog(false);
		}).catch((error)=>{
            showError(error.response.data?error.response.data.message:error.message);
        });
	}
	const onBackToTest=()=>{
		nav('/test/'+testId);
	}
	const testHeader=()=>{
		return(
		<div className='flex flex-row gap-4 m-2 justify-content-between'>
			<div className="flex gap-4">
			<KeyValue values={[{key:t('Test'),value:test.name+' ('+test.itemCount+')'}]}/>
			<KeyValue values={[{key:t('Section'),value:sect.name+' ('+sect.itemCount+')'}]}/>
			</div>
			<Button severity='secondary' label={t('Back_To_Test')} onClick={onBackToTest}/>
		</div>
		)
	}
	const onSearchTestCancel=()=>{setSearchTestDialog(false)}
	const deleteMenuProp = deleteMenu != undefined?deleteMenu:false;
	return (
		<>
		{mode == 'addToTest'?testHeader():''}
		<Tooltip target=".custom-target-icon" />
		<div style={{height:calculatedHeight}} ref={childRef}>
		<GenericGrid dialogHeader={t('Question')} recType="Question" loadRecords={loadRecords} reload={reload}
				parentId={catId} dataKey="id" 
				commandMenuItems={commandMenuItems} commandAction={commandAction}
				currentRowChanged={selectionChangedCallback}
				deleteMenu={deleteMenuProp} exportMenu commandMenu filterMenu paginator={false}
				style={{height:'100%'}}
			> 
			<Column header={t('QueGrid.Id')} field="id" style={{width:'5%'}} sortable body={idTemplate}></Column>
			<Column header={t('QueGrid.G')} field="g" headerTooltip={t('Question_Group')} style={{width:'5%'}} body={grpTemplate}></Column>
			<Column header={t('QueGrid.L')} field="locked" headerTooltip={t('Lock_Status')} style={{width:'5%'}} body={lockTemplate}></Column>
			<Column header={t('QueGrid.A')} field="approved" headerTooltip={t('Approval_Status')} style={{width:'5%'}} body={approveTemplate}></Column>
			<Column header={t('QueGrid.Type')} field="itemType" sortable body={itemTypeTemplate}/>
			<Column header={t('Course')} field='courseName' style={{minWidth:'150px',textWrap:'nowrap'}} sortable/>
			<Column header={t('Topic')} field='topicName' style={{minWidth:'150px',textWrap:'nowrap',textOverflow:'ellipsis'}} sortable/>
			<Column header={t('Difficulty')} field='difficulty' sortable/>
			<Column header={t('Answer')} field='answer' style={{width:'10%',textWrap:'nowrap',textOverflow:'ellipsis'}}/>
			<Column header={t('Creation_Date')} field='timeCreated' style={{minWidth:'150px'}} sortable/>
			<Column header={t('QueGrid.Used')} field='usages' sortable/>
			<Column header={t('QueGrid.Group')} field='groupName' sortable/>
			<Column header={t('QueGrid.Quality')} field='itemQuality' sortable/>
			<Column header={t('QueGrid.Discr')} field='itemDiscr' sortable/>
			<Column header={t('QueGrid.Diff')} field='itemDiff' sortable/>
		</GenericGrid>		
		</div>
		{
			catSelectDialog?
			<CatSelectDialog visible={catSelectDialog} 
				onOK={onCatSelectOK} onCancel={onCatSelectCancel}>
			</CatSelectDialog>:''
		}
		{
			propDialog?
			<SetProp visible={propDialog} 
				onOK={onSetPropOK} onCancel={onSetPropCancel}>
			</SetProp>:''
		}
		{
			catSelectListDialog?
			<CatSelectListDialog visible={catSelectListDialog} parentId={9} catType={catType}
				onOK={onCatSelectListOK} onCancel={onCatSelectListCancel}>
			</CatSelectListDialog>:''
		}
		{
			searchTestDialog?
			<TestSearchDialog visible={searchTestDialog} sectionSelect={true} selectionMode="single"
				onOK={onSearchTestOK} onCancel={onSearchTestCancel}>
			</TestSearchDialog>:''
		}
		{
			printDialog?
			<PrintDialog visible={printDialog} items={selectedItems} onOK={onPrintOK} mode={printMode} onCancel={onPrintCancel} testId={0} test={dummyTest}>
			</PrintDialog>:''
		}
		</>
	)
}
export default QueGrid;
